export default __webpack_public_path__ + "static/playar-ad030f56b4fda10c4e68889dff8bfe71.mp4";